'use client'

import { Sidebar, SidebarContent } from '@repo/ui/components'

import { appPanels, useRightPanelContext } from './context.tsx'

/** Supplies the docked/mobile sidebar and the portal target for the active panel. */
const RightPanelShell = () => {
  const { resize, setPortalHost, shellWidth } = useRightPanelContext()

  return (
    <Sidebar
      className="[&>[data-slot=sidebar-inner]]:overflow-hidden [&>[data-slot=sidebar-inner]]:rounded-xl [&>[data-slot=sidebar-inner]]:shadow-sm"
      name={appPanels.rightPanel}
      resize={resize}
      side="right"
      variant="inset"
      width={shellWidth}
    data-sentry-element="Sidebar" data-sentry-component="RightPanelShell" data-sentry-source-file="right-panel-shell.tsx">
      <SidebarContent className="px-2 pl-0" ref={setPortalHost} data-sentry-element="SidebarContent" data-sentry-source-file="right-panel-shell.tsx" />
    </Sidebar>
  )
}

export { RightPanelShell }
